// src/components/FacturationEditTable.js
import React from "react";
import { Badge } from "react-bootstrap";
import "./facturationEditTable.css";

function FacturationEditTable({
  facturations,
  selectedGestionnaires,
  searchRaisonSociale,
  selectedStatut,
  filterBySelectedMonth,
  openEditModal,
}) {
  return (
    <table className="facturation_table">
      <thead>
        <tr>
          <th>Raison Sociale</th>
          <th>Gestionnaire</th>
          <th>Bulletin</th>
          <th>STC</th>
          <th>Maladie</th>
          <th>RC</th>
          <th>Contrat</th>
          <th>Licenciement</th>
          <th>Mission excep</th>
          <th>Avenant</th>
          <th>Teulade</th>
          <th>Accès SILAE</th>
          <th>Statut</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {facturations
          .filter((f) =>
            selectedGestionnaires.length === 0 ||
            selectedGestionnaires.includes(f.gestionnaire_nom)
          )
          .filter((f) =>
            f.raison_sociale?.toLowerCase().includes(searchRaisonSociale.toLowerCase()) ||
            f.siret?.includes(searchRaisonSociale)
          )
          .filter(filterBySelectedMonth)
          .filter((f) => !selectedStatut || f.statut === selectedStatut)
          .map((f) => (
            <tr key={f.id}>
              <td>
                <div>{f.raison_sociale}</div>
                <div>{f.siret}</div>
              </td>
              <td>{f.gestionnaire_nom}</td>
              <td>{f.bulletin}</td>
              <td>{f.stc}</td>
              <td>{f.maladie}</td>
              <td>{f.RC}</td>
              <td>{f.contrat}</td>
              <td>{f.licenciement}</td>
              <td>{f.mission_excep}</td>
              <td>{f.avenant}</td>
              <td>{f.teulade}</td>
              <td>{f.acces_silae}</td>
              <td>
                <Badge bg={
                  f.statut === "Terminé" ? "success" :
                  f.statut === "En revue" ? "primary" :
                  f.statut === "A revoir" ? "warning" :
                  f.statut === "A faire" ? "secondary" :
                  "info"
                  
                }
                className={`select-status ${f.statut} width-status`  }>

                  {f.statut}
                </Badge>
              </td>
              <td>
                <button
                  className="btn-declarer"
                  onClick={() => openEditModal(f)}
                  disabled={f.statut === "Terminé"}
                  style={{ opacity: f.statut === "Terminé" ? 0 : 1 }}
                >
                  Déclarer
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

export default FacturationEditTable;
